import { createFileRoute } from "@tanstack/react-router";
import { VisibleProfile } from "@/features/profile/VisibleProfile";
function Page() {
  const { userId } = Route.useParams();
  const { session } = Route.useRouteContext();
  return (
    <VisibleProfile
      key={`${session.user.id}:${userId}`}
      actorId={session.user.id}
      userId={userId}
    />
  );
}
export const Route = createFileRoute(
  "/_authenticated/_protected/users/$userId",
)({ component: Page });
